const searchTracks = async (query) => {
  try {
    if (!query) return [];

    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/track/search/${encodeURIComponent(query)}`,
    );

    if (!response.ok) {
      const errorMessage = await response.text();
      throw new Error(errorMessage || 'Failed to fetch tracks');
    }

    const data = await response.json();
    return data.tracks || [];
  } catch (err) {
    console.error('Error fetching tracks:', err);
    return [];
  }
};

export { searchTracks };
